const LVDentalLight = () => (
	<>
		<path
			d="M22.3076 3.38477C25.7909 3.38489 28.6152 6.14179 28.6152 9.54199C28.6152 10.6004 28.341 12.7621 27.8586 15.238C27.3074 18.0669 27.2004 20.9814 26.7047 23.8206C26.2619 26.3565 25.2052 28.1172 23.7061 28.3984C21.7341 28.7684 19.5485 26.4745 18.0928 22.8701C17.5818 22.0934 16.9151 20.1354 16.0713 20.1352C15.2244 20.1352 14.5549 22.0977 14.043 22.8779C12.5873 26.4777 10.4041 28.7681 8.43359 28.3984C6.90218 28.1111 5.8328 26.28 5.40794 23.6557C4.86841 20.3231 4.80024 16.9007 4.11121 13.5957C3.74303 11.8298 3.52344 10.3579 3.52344 9.54199C3.52352 6.14171 6.34764 3.38477 9.83105 3.38477C10.8852 3.3848 11.8786 3.63859 12.752 4.08496C13.485 4.3702 14.5685 4.70013 16.0674 4.7002C17.5699 4.7002 18.656 4.36873 19.3896 4.08301C20.2622 3.63771 21.2548 3.38477 22.3076 3.38477Z"
			fill="white"
		/>
		<path
			d="M22.3076 6.75076C21.2548 6.75076 20.2622 7.00371 19.3896 7.44901C18.656 7.73473 17.5699 8.06619 16.0674 8.06619C14.5685 8.06613 13.485 7.7362 12.752 7.45096C11.8786 7.00459 10.8852 6.7508 9.83105 6.75076"
			stroke="#00084D"
			strokeWidth="0.75"
			strokeLinecap="round"
		/>
	</>
);

export default LVDentalLight;
